import { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid
} from '@mui/material';
import LanguageBarChart from './LanguageBarChart';
import { RoleContext } from 'src/context/roleContext';
import { useTranslation } from 'react-i18next';
import { API_BASE_URL } from 'src/apiConfig';

/* STRANA GDE JE STATISTIKA PO JEZICIMA I ZA ADMINA I ZA SKOLU */

const StatisticsByLanguage = () => {
  const [studentCountByLanguage, setStudentCountByLanguage] = useState([]);
  const { schoolId } = useContext(RoleContext);
  const { t } = useTranslation();

  useEffect(() => {
    const fetchStudentCountByLanguage = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/statistics.php/`,
          {
            params: {
              statistics: 'student_count_by_language',
              schoolid1: schoolId ? schoolId[0] : null
            }
          }
        );
        if (Array.isArray(response.data)) {
          setStudentCountByLanguage(response.data);
        } else {
          console.error('Expected array, got:', response.data);
        }
      } catch (error) {
        console.error('Error fetching student count by language:', error);
      }
    };

    fetchStudentCountByLanguage();
  }, [schoolId]);

  return (
    <Box m="20px">
      {/* Naslov stranice */}
      <Typography
        variant="h4"
        align="center"
        gutterBottom
        sx={{
          fontWeight: 'bold',
          color: '#1976d2',
          mb: '40px',
          textTransform: 'uppercase'
        }}
      >
        {t('statistic.pageTitle')}
      </Typography>

      {/* Raspored stranice */}
      <Grid container spacing={4}>
        <Grid item xs={12} md={8}>
          <Paper
            elevation={3}
            sx={{
              p: '20px',
              borderRadius: '16px',
              boxShadow: '0px 6px 12px rgba(0, 0, 0, 0.1)',
              backgroundColor: '#ffffff'
            }}
          >
            <Typography
              variant="h6"
              align="center"
              gutterBottom
              sx={{ color: '#1F78B4', fontWeight: 'bold' }}
            >
              {t('statistic.studentCountByLanguage')}
            </Typography>
            <LanguageBarChart
              data={studentCountByLanguage}
              dataKeyName="Broj Ucenika"
            />
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper
            elevation={3}
            sx={{
              p: '20px',
              borderRadius: '16px',
              boxShadow: '0px 6px 12px rgba(0, 0, 0, 0.1)',
              backgroundColor: '#f4f6f8'
            }}
          >
            <Typography
              variant="h6"
              align="center"
              gutterBottom
              sx={{ color: '#1F78B4', fontWeight: 'bold' }}
            >
              {t('statistic.languageTableTitle')}
            </Typography>
            <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      align="center"
                      sx={{ fontWeight: 'bold', color: '#1976d2' }}
                    >
                      {t('statistic.language')}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ fontWeight: 'bold', color: '#1976d2' }}
                    >
                      {t('statistic.studentCount')}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.isArray(studentCountByLanguage) &&
                    studentCountByLanguage.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell align="center">
                          {t(`statistic.languages.${row['Jezik']}`) ||
                            row['Jezik']}
                        </TableCell>
                        <TableCell align="center">
                          {row['Broj Ucenika']}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default StatisticsByLanguage;
